import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { SkynetAuthProvider } from "./auth";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { applySkin } from "./pixel/skin";
import { startPwa, ThemeColor } from "./pwa";
import "./index.css";

applySkin();
startPwa();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: true, staleTime: 2000 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <ThemeColor />
      <SkynetAuthProvider>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delayDuration={200}>
            <App />
            <Toaster richColors closeButton />
          </TooltipProvider>
        </QueryClientProvider>
      </SkynetAuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
